module.exports = __webpack_public_path__ + "media/images/icon/file-27f934831380f311e20986debda3e788.svg";